var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], {"dev":false,"autoescape":true,"throwOnUndefined":false,"trimBlocks":false,"lstripBlocks":false});
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("C:/Users/kaharmanny/source/repos/rentmagic.frontend/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["views/snippet/notification.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div role=\"alert\" >\r\n    <div class=\"row no-gutters sleek-notification\" data-notify=\"dismiss\">\r\n        <div class=\"sleek-notification-icon col-3 text-center align-items-center\">\r\n        \r\n            ";
if(runtime.contextOrFrameLookup(context, frame, "type") === "success") {
output += "\r\n                <div class=\"logo-icon pl-0 pr-0 pt-1 text-success\"><i class=\"fa fa-check\"></i></div>\r\n            ";
;
}
output += "\r\n\r\n            ";
if(runtime.contextOrFrameLookup(context, frame, "type") === "warning") {
output += "\r\n                <div class=\"logo-icon pl-0 pr-0 pt-1 text-warning\"><i class=\"fas fa-exclamation-triangle\"></i></div>\r\n            ";
;
}
output += "\r\n\r\n            ";
if(runtime.contextOrFrameLookup(context, frame, "type") === "danger") {
output += "  \r\n                <div class=\"logo-icon pl-0 pr-0 pt-1 text-danger\"><i class=\"fas fa-exclamation-circle\"></i></div>\r\n            ";
;
}
output += "\r\n\r\n            ";
if(runtime.contextOrFrameLookup(context, frame, "type") === "info") {
output += "\r\n                <span class=\"logo-icon pl-0 pr-0 infodatek-icon infodatek-icon-";
output += runtime.suppressValue(env.getFilter("lower").call(context, runtime.contextOrFrameLookup(context, frame, "product")), env.opts.autoescape);
output += "\"></span>\r\n            ";
;
}
output += "\r\n\r\n            ";
if(runtime.contextOrFrameLookup(context, frame, "type") === "primary") {
output += "\r\n                <span class=\"logo-icon pl-0 pr-0 infodatek-icon infodatek-icon-";
output += runtime.suppressValue(env.getFilter("lower").call(context, runtime.contextOrFrameLookup(context, frame, "product")), env.opts.autoescape);
output += "\" ></span>\r\n            ";
;
}
output += "\r\n            \r\n        </div>\r\n        <div class=\"sleek-notification-body col-9\">\r\n            <a href=\"#closeNotification\" class=\"float-right pr-2 pt-1 no\" data-notify=\"dismiss\"><i class=\"far fa-times\"></i></a>\r\n            <div class=\"sleek-notification-body-text mr-4 text-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "type"), env.opts.autoescape);
output += " \">{2}</div>\r\n        </div>\r\n    </di\r\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["views/snippet/notification.html"] , dependencies)